import PptxGenJS, { Slide } from "pptxgenjs"
import {createAnnuitySection} from "../annuity-generator"
import {createCapitalReimbursementSection} from "../capital-reimbursement-generator"
import {createInterestReimbursementSection} from "../interest-reimbursement-generator"
import {createRemainingCapitalSection} from "../remaining-capital-generator"
import * as CapaciteNetteGen from "./../capacite-nette-generator"
import * as CapaciteBruteGen from "./../capacite-brute-generator"
import * as OperationsDepenses from "./../depenses-generator"
import * as RecettesReelles from "./../recettes-generator"
import * as DepensesReelles from "./../depenses-reelles-generator"
import * as ResultatAnnee from "./../resultat-de-annee"
import * as OperationRecettes from "./../operations-recettes-generator"
import { ReportConfiguration } from "../../../configuration"
import { MasterSlide } from "../../pptx-configuration/master-slides"
import { Placeholder } from "../../pptx-configuration/placeholders"
import { DocumentSection } from "../../types"
import { formatTitle } from "../utils"
import * as Model from "../../../../../model"
import * as DebtUtils from "../utils"
import * as Constants from "../../pptx-configuration/constants"

export function createBudgetAnnexes(
	pptx: PptxGenJS,
	configuration: ReportConfiguration,
	numbering: number[],
	localAuthority: Model.LocalAuthority,
	scenario: Model.Scenario,
	ppi: Model.Ppi,
	loanDecompositions: Model.LoanDecomposition[],
	years: number[],
	budgetData: any
): DocumentSection {

    const summarySlide = pptx.addNewSlide(MasterSlide.Default)
    const slides: Slide[] = []
	const subTitles: string[] = []
    const title = formatTitle("Compilation des budgets annexes", numbering)
    summarySlide.addText(title, { placeholder: Placeholder.Title })

    let subsectionNumber = 0

	const recettesReellesSection = RecettesReelles.createRecettesReellesSection(
        pptx,
        configuration,
        numbering.concat(++subsectionNumber),
        localAuthority,
        scenario,
        ppi,
        loanDecompositions,
        years,
        budgetData
    )
    recettesReellesSection.slides.forEach(s => slides.push(s))
    subTitles.push(recettesReellesSection.title)

    const depensesReellesSection = DepensesReelles.createDepensesReellesSection(
        pptx,
        configuration,
        numbering.concat(++subsectionNumber),
        localAuthority,
        scenario,
        ppi,
        loanDecompositions,
        years,
        budgetData
    )
    depensesReellesSection.slides.forEach(s => slides.push(s))
    subTitles.push(depensesReellesSection.title)

    const operationsRecettesSection = OperationRecettes.createOperationsRecettesSection(
        pptx,
        configuration,
        numbering.concat(++subsectionNumber),
        localAuthority,
        scenario,
        ppi,
        loanDecompositions,
        years,
        budgetData
    )
    operationsRecettesSection.slides.forEach(s => slides.push(s))
    subTitles.push(operationsRecettesSection.title)
    
    const operationsDepenses = OperationsDepenses.createOperationsDepensesSection(
        pptx,
        configuration,
        numbering.concat(++subsectionNumber),
        localAuthority,
        scenario,
        ppi,
        loanDecompositions,
        years,
        budgetData
    )
    operationsDepenses.slides.forEach(s => slides.push(s))
    subTitles.push(operationsDepenses.title)

    const resultatDeAnnee = ResultatAnnee.createResultatDeAnneeSection(
        pptx,
        configuration,
        numbering.concat(++subsectionNumber),
        localAuthority,
        scenario,
        ppi,
        loanDecompositions,
        years,
        budgetData
    )
    resultatDeAnnee.slides.forEach(s => slides.push(s))
    subTitles.push(resultatDeAnnee.title)

    const capaciteBruteSection = CapaciteBruteGen.createCapaciteBruteSection(
        pptx,
        configuration,
        numbering.concat(++subsectionNumber),
        localAuthority,
        scenario,
        ppi,
        loanDecompositions,
        years,
        budgetData
    )
    capaciteBruteSection.slides.forEach(s => slides.push(s))
    subTitles.push(capaciteBruteSection.title)

    const capaciteNetteSection = CapaciteNetteGen.createCapaciteNetteSection(
        pptx,
        configuration,
        numbering.concat(++subsectionNumber),
        localAuthority,
        scenario,
        ppi,
        loanDecompositions,
        years,
        budgetData
    )
    capaciteNetteSection.slides.forEach(s => slides.push(s))
    subTitles.push(capaciteNetteSection.title)

    summarySlide.addText(
		subTitles.map(t => ({ text: t, options: { breakLine: true }})),
            Constants.getTextPlacementOptions
	)


	return { title, slides }
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/budgetGenerator/budget-Annexes/index.tsx